import React, { Component } from "react";
import { types, PropTypes } from "Subschema";
import CustomMaskedInput from "../card/CustomMaskedInput";
import _isFunction from "lodash/Lang/isFunction";

export default class SsnNine extends Component {

  constructor(props, ...rest) {
    super(props, ...rest);
  }


  render() {
    const {
      className,
      error,
      creditCardClass,
      hasErrorClass,
      onChange,
      mask,
      ssnChecked,
      maskedInoutUnsupported,
      ...props
    } = this.props;

    let showSsn = ssnChecked === false ? false : ssnChecked || true;


    return (
      <span className={className}>
        <CustomMaskedInput
          {...props}
          placeholderChar=''
          mask={mask || '111-11-1111'}
          hidableMaskedInput={true}
          hideSSN = {this.props.ssnChecked}
          onChange={this.props.onChange}/>
        <i className={`${error ? hasErrorClass : ''}`}/>
    </span>)
  }
}


SsnNine.propTypes = {
  "onChange": PropTypes.targetEvent,
  "style": PropTypes.style,
  "mask": PropTypes.string,
  "error": PropTypes.error,
  "ssnChecked": PropTypes.value
};

SsnNine.defaultProps = {
  "ssnChecked": "_internal.ssnChecked"
};

SsnNine.contextTypes = {
  "maskedInoutUnsupported": React.PropTypes.bool
};



/** WEBPACK FOOTER **
 ** ./src/types/credit/SsnNine.jsx
 **/